import { IconProps } from '@/shared/lib/types'
import { getStatusColors } from '@/shared/utils/getStatusColors'

export const DeviceIcon = ({ status, className }: IconProps) => {
  const { fillColor, strokeColor } = getStatusColors(status)

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill={fillColor} />
      <path
        d="M12 18C12 14.229 12 12.343 13.172 11.172C14.344 10.001 16.229 10 20 10C23.771 10 25.657 10 26.828 11.172C27.999 12.344 28 14.229 28 18V22C28 25.771 28 27.657 26.828 28.828C25.656 29.999 23.771 30 20 30C16.229 30 14.343 30 13.172 28.828C12.001 27.656 12 25.771 12 22V18Z"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <path d="M23 27H17" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}
